import React from 'react';
import Header from '../components/Common/Header';
import './LegalPages.css';

const Privacy = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <h1>Privacy Policy</h1>

          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              Bihar Election ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains 
              how we collect, use, disclose, and safeguard your information when you use our Bihar Election Tracker 
              application and services.
            </p>
            <p>
              We are a private entity and not affiliated with any government organization.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information We Collect</h2>
            
            <h3>2.1 Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide, including:</p>
            <ul>
              <li>Name and contact information (email, phone number)</li>
              <li>Account credentials (username, password)</li>
              <li>Profile information</li>
              <li>Survey responses and poll participation data</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>When you access our Service, we automatically collect:</p>
            <ul>
              <li>Device information (IP address, browser type, operating system)</li>
              <li>Usage data (pages visited, time spent, click patterns)</li>
              <li>Location data (if you grant permission)</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information for:</p>
            <ul>
              <li>Providing and maintaining our Service</li>
              <li>Personalizing user experience</li>
              <li>Conducting surveys and polls</li>
              <li>Sending notifications and updates</li>
              <li>Analyzing usage patterns and improving our Service</li>
              <li>Detecting and preventing fraud or abuse</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We do NOT sell your personal information. We may share your information only in the following circumstances:</p>
            <ul>
              <li><strong>With your consent:</strong> When you explicitly authorize us to share</li>
              <li><strong>Service providers:</strong> Third-party vendors who assist in operating our Service</li>
              <li><strong>Legal requirements:</strong> When required by law or to protect our rights</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information against 
              unauthorized access, alteration, disclosure, or destruction.
            </p>
            <p>Security measures include:</p>
            <ul>
              <li>Encryption of sensitive data</li>
              <li>Regular security audits</li>
              <li>Access controls and authentication</li>
              <li>Secure data storage practices</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Your Rights and Choices</h2>
            <p>You have the following rights regarding your personal information:</p>
            <ul>
              <li><strong>Access:</strong> Request access to your personal data</li>
              <li><strong>Correction:</strong> Request correction of inaccurate data</li>
              <li><strong>Deletion:</strong> Request deletion of your personal data</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
            </ul>
            <p>To exercise these rights, please contact us at contact@bihar.com.co</p>
          </section>

          <section className="legal-section">
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to enhance user experience. You can control cookie 
              preferences through your browser settings.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Children's Privacy</h2>
            <p>
              Our Service is not intended for users under the age of 18. We do not knowingly collect personal information 
              from children.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any material changes by posting 
              the new policy on this page.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us:</p>
            <ul>
              <li>Email: contact@bihar.com.co</li>
              <li>Phone: +91 7482909107</li>
              <li>Address: Patna, Bihar 800001, India</li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
};

export default Privacy;
